define('app-formElementsTP/main',[], function () {
    return {
        run: function () {
            $('input.cbxPassenger').each(function () {
                var inputID = $(this).attr('id');

                if (($(this).attr('data-alreadybooked') || '').toLowerCase() == 'true') {
                    $('label[for="' + inputID + '"]').addClass("booked");
                }
            });

            //Toggle the amount input on payment options page
            $("#payment-options .radio-button").on("click",
                function () {
                    $(this).find("input")[0].value === "paycustomvalue"
                        ? $('#customAmountContainer').removeClass("hidden")
                        : $('#customAmountContainer').addClass("hidden");
            });
        }
    }
});
